module.exports = __webpack_public_path__ + "img/foldable_grocery.9461dea9.jpg";